import {Component, EventEmitter, Inject, Input, Output, PLATFORM_ID} from '@angular/core';
import {User, UserRoles} from '../../../core/entities/user/user.entity';

import {TranslocoPipe, TranslocoService} from '@jsverse/transloco';
import {Router, RouterLink} from '@angular/router';
import {AuthenticationService} from '../../../core/services/authentication/authentication.service';
import {ToastrService} from 'ngx-toastr';
import {isPlatformBrowser} from '@angular/common';

@Component({
  selector: 'app-header-user-menu',
  imports: [
    TranslocoPipe,
    RouterLink
],
  templateUrl: './header-user-menu.component.html',
  styleUrl: './header-user-menu.component.scss'
})
export class HeaderUserMenuComponent {
  @Input() user: User|null = null;
  @Output() onClose = new EventEmitter<void>();

  public constructor(
    private readonly authenticationService: AuthenticationService,
    private readonly toastr: ToastrService,
    private readonly transloco: TranslocoService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {}

  public logout(): void {
    this.authenticationService.logout();
    this.toastr.success(
      this.transloco.translate('marketplace.header.user-menu.logout-message.content'),
      this.transloco.translate('marketplace.header.user-menu.logout-message.title'),
    );
    this.user = this.authenticationService.getCurrentUser();
    this.close();
    if (isPlatformBrowser(this.platformId)) {
      window.location.reload();
    }
  }

  public isCustomer(): boolean
  {
    return this.user !== null && this.user.roles.includes(UserRoles.customer);
  }

  public isPhotographer(): boolean
  {
    return this.user !== null && this.user.roles.includes(UserRoles.photographer);
  }

  public isAdmin(): boolean
  {
    return this.user !== null && this.user.roles.includes(UserRoles.admin);
  }

  public getCguClientHref(): string {
    const lang = this.transloco.getActiveLang();
    return lang === 'fr'
      ? '/assets/documents/customer/CGU-fr.pdf'
      : '/assets/documents/customer/ToU-en.pdf';
  }

  public getLegalNoticeHref(): string {
    const lang = this.transloco.getActiveLang();
    return lang === 'fr'
      ? '/assets/documents/mentions-legales.pdf'
      : '/assets/documents/legal-notice.pdf';
  }

  public getPrivacyPolicyHref(): string {
    const lang = this.transloco.getActiveLang();
    return lang === 'fr'
      ? '/assets/documents/politique-de-confidentialite.pdf'
      : '/assets/documents/privacy-policy.pdf';
  }

  public close(): void {
    this.onClose.emit();
  }
}
